import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { designTokens } from "@cinch-labs/design-system";
import cx from "classnames";
import React from "react";
import styles from "./loading-spinner.module.css";
var _ds = designTokens.customProperties.ds, palette = _ds.color;
var DEFAULT_SIZE = 32;
export var LoadingSpinner = function(param) {
    var _backgroundCircleColor = param.backgroundCircleColor, backgroundCircleColor = _backgroundCircleColor === void 0 ? palette.gainsboro : _backgroundCircleColor, _foregroundCircleColor = param.foregroundCircleColor, foregroundCircleColor = _foregroundCircleColor === void 0 ? palette.deepPurple : _foregroundCircleColor, _size = param.size, size = _size === void 0 ? DEFAULT_SIZE : _size, className = param.className;
    var classNames = cx(styles.loadingSpinner, className);
    return /*#__PURE__*/ _jsxs("svg", {
        className: classNames,
        xmlns: "https://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        "data-testid": "LoadingSpinner",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "16",
                r: "11",
                stroke: backgroundCircleColor
            }),
            /*#__PURE__*/ _jsx("path", {
                className: styles.foregroundCircle,
                d: "M5,16a11,11 0 1,0 22,0a11,11 0 1,0 -22,0",
                stroke: foregroundCircleColor
            })
        ]
    });
};
export default LoadingSpinner;
